import { useAppSelector } from '@/store/hooks';
import { useGetMeQuery } from '@/services/endpoints/auth';
import { laravelOwnsData } from '@/lib/dataOwner';

/**
 * L'utente QLASH corrente, da UNA fonte sola per build.
 *
 * 🔴 IL GUASTO CHE CHIUDE, misurato da `or45` su `stg-tma` il 2026-09-05. La PR #126 aveva
 * spostato l'identita' del boot su Limulo, ma cinque schermate ripetevano questo idioma:
 *
 *     const meFromStore = useAppSelector((s) => s.auth.user);
 *     const meQuery = useGetMeQuery(undefined, { skip: !!meFromStore });
 *     const me = meFromStore ?? meQuery.data ?? null;
 *
 * ⚠️ `skip: !!meFromStore` sembra sufficiente e non lo e': **nella finestra fra il montaggio
 * e la risposta di `/v1/me` di Limulo, `meFromStore` e' ancora `null`** — quindi lo skip non
 * scatta e parte Laravel. Ogni chiamata Laravel tira poi il proprio `exchange-token`.
 * Misurato: **12 `exchange-token` 503 e 4 `/users/me` 503 per giro**, anche su rotte
 * `/limulo/*` pure, su una build in cui Laravel non dovrebbe essere toccato.
 *
 * 📌 ***#126 non era un interruttore, era una CORSA*** — e una corsa non si vince mettendo
 * la condizione giusta piu' presto: si vince togliendo il secondo concorrente. Qui la
 * domanda non e' piu' «ho gia' l'utente?» (uno stato che cambia nel tempo) ma «di chi e'
 * l'identita' su questa build?» (una costante di compilazione).
 *
 * ⚠️ Con il flag spento — cioe' in PRODUZIONE — il comportamento e' **identico a prima** per
 * costruzione: `laravelOwnsIdentity` e' vero, e lo skip torna a dipendere solo dallo store.
 */
export function useQlashUser() {
  const fromStore = useAppSelector((s) => s.auth.user);

  const meQuery = useGetMeQuery(undefined, {
    // Costante di build, non stato — la regola ha una sede sola: `lib/dataOwner.ts`.
    skip: !!fromStore || !laravelOwnsData(),
  });

  // ⚠️ Il ripiego su `meQuery.data` resta, e serve: su una build Laravel lo store si popola
  // da `useLogtoAuth`, ma una schermata puo' montare prima. Su una build Limulo la query e'
  // spenta, quindi `data` e' `undefined` e il ripiego non fa nulla — che e' l'esito voluto.
  return fromStore ?? meQuery.data ?? null;
}
